import { ZebraPrintCargoLabel } from "../../../../data/usecases/print-label/print-cargo-label";
import { PrintCargoLabel } from "../../../../domain/usecases/print-label/print-cargo-label";
import { ZebraLabelPrinter } from "../../../../infra/label-printer/zebra-label-printer";

export const makePrintCargoLabel = (): PrintCargoLabel =>
  new ZebraPrintCargoLabel(new ZebraLabelPrinter());
